import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import jumpToMiniprogram from '@/components/jumpToMiniprogram'
import video from '@/pages/video'
import allvideo from '@/pages/allvideo'
import purchase from '@/pages/purchase'
import activityPoster from '@/pages/activityPoster'
import qcwy from './modules/qcwy'
import qiwei from './modules/qiwei'
import usedexcavator from './modules/usedexcavator'
// console.log(...qiwei)
Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        // {
        //     path: '/',
        //     name: 'HelloWorld',
        //     component: HelloWorld
        // },
        {
            path: '/jumpToMiniprogram',
            name: 'jumpToMiniprogram',
            component: jumpToMiniprogram
        },
        {
            path: '/video',
            name: 'video',
            component: video,
            meta: {
                title: 'Digital Project Briefing'
            }
        },
        {
            path: '/allvideo',
            name: 'video',
            component: allvideo,
            meta: {
                title: 'Digital Project allBriefing'
            }
        },
        {
            path: '/purchase',
            name: 'purchase',
            component: purchase,
            meta: {
                title: '购机意向'
            }
        },
        {
            path: '/activityPoster',
            name: 'activityPoster',
            component: activityPoster,
            meta: {
                title: '海报分享'
            }
        },
        ...qcwy,
        ...qiwei,
        ...usedexcavator,
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js